export default "__VITE_ASSET__DRgNXEdE__"